import { LANGUAGES, useI18n } from '../i18n';

export function LanguageFlags({ placement = 'menu', onChoose }) {
  const { language, setLanguage, t } = useI18n();
  const gate = placement === 'gate';
  const prefix = gate ? 'language-gate' : `${placement}-language`;
  return <div className={`language-flags ${gate ? 'gate-flags' : 'header-flags'}`} role="group" aria-label={t(gate ? 'chooseLanguage' : 'changeLanguage')} data-testid={gate ? 'language-gate-flags' : `${placement}-language-selector`}>
    {LANGUAGES.map(item => <button
      key={item.code}
      type="button"
      className={`flag-button ${item.code === language ? 'is-selected' : ''}`}
      aria-label={item.name}
      aria-pressed={item.code === language}
      title={item.name}
      lang={item.code}
      data-testid={`${prefix}-flag-${item.code}`}
      onClick={() => { setLanguage(item.code); onChoose?.(item.code); }}
    ><img src={item.flag} width="36" height="24" alt="" aria-hidden="true" draggable="false"/><span className="flag-selection" aria-hidden="true"/></button>)}
  </div>;
}
